var module = angular.module('octopusApp.configuration');

module.controller('TeamEditRoleDialogController', function($scope, busy, $uibModalInstance, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();

  isLoading.promise(octopusRepository.UserRoles.all().then(function (userRoles) {
    $scope.roleParticipation = { userRoleId: null };
    $scope.userRoles = userRoles;
  }));

  $scope.getRole = function() {
    return _.find($scope.userRoles, function (a) {
      return a.Id === $scope.roleParticipation.userRoleId;
    });
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    if ($scope.roleParticipation.userRoleId) {
      $uibModalInstance.close($scope.roleParticipation.userRoleId);
    }
  };
});






//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_edit_role_dialog_controller.js
// module id = 404
// module chunks = 1